export default __webpack_public_path__ + "static/media/Path3438.0c6f773b.svg";